/*
 * O mapa do tópico entra logo depois do primeiro post, pelo
 * afterFirstPostItems do PostStream (um chunk carregado sob demanda, daí o
 * extend pelo nome do módulo).
 */
import { extend } from 'flarum/common/extend';
import TopicMap, { hasTopicMap } from './components/TopicMap';
import { topicSettings } from './ui';
export default function installTopicMap() {
  extend('flarum/forum/components/PostStream', 'afterFirstPostItems', function (items) {
    if (!topicSettings.map() || !this.discussion || !hasTopicMap(this.discussion)) return;
    items.add('canelaTopicMap', m(TopicMap, {
      discussion: this.discussion
    }), 100);
  });
}
flarum.reg.add('ramon-canela', 'forum/topic/topicMap', installTopicMap);